import React, { useRef, useState } from 'react';
import './BookingDateInput.css';

// Keep the month being browsed separate from the reservation's selected date.
export default function BookingDateInput({ value, onChange }) {
  const selected = /^\d{4}-\d{2}-\d{2}$/.test(value || '')
    ? new Date(`${value}T12:00:00`) : new Date();
  const [month, setMonth] = useState(() => new Date(selected.getFullYear(), selected.getMonth(), 1));
  const [open, setOpen] = useState(false);
  const trigger = useRef(null);
  const year = month.getFullYear();
  const index = month.getMonth();
  const offset = (new Date(year, index, 1).getDay() + 6) % 7;
  const count = new Date(year, index + 1, 0).getDate();
  const dateValue = day => `${year}-${String(index + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
  const close = () => { setOpen(false); trigger.current?.focus(); };
  return <div className="booking-date-input" onKeyDown={event => {
    if (event.key === 'Escape' && open) { event.stopPropagation(); close(); }
  }}>
    <button ref={trigger} type="button" className="booking-date-input__trigger" aria-label="Cambiar fecha de la reserva" aria-expanded={open} onClick={() => {
      if (!open) setMonth(new Date(selected.getFullYear(), selected.getMonth(), 1));
      setOpen(!open);
    }}>
      <span>{selected.toLocaleDateString('es-PA', { day: 'numeric', month: 'long', year: 'numeric' })}</span>
      <span aria-hidden="true">⌄</span>
    </button>
    {open && <div className="booking-date-input__calendar" role="group" aria-label="Seleccionar fecha">
      <div className="booking-date-input__heading">
        <button type="button" aria-label="Mes anterior" onClick={() => setMonth(new Date(year, index - 1, 1))}>‹</button>
        <strong aria-live="polite">{month.toLocaleDateString('es-PA', { month: 'long', year: 'numeric' })}</strong>
        <button type="button" aria-label="Mes siguiente" onClick={() => setMonth(new Date(year, index + 1, 1))}>›</button>
      </div>
      <div className="booking-date-input__days">
        {['L', 'M', 'X', 'J', 'V', 'S', 'D'].map((day, i) => <span key={`week-${i}`} aria-hidden="true">{day}</span>)}
        {Array.from({ length: offset }, (_, i) => <span key={`blank-${i}`} />)}
        {Array.from({ length: count }, (_, i) => i + 1).map(day => <button key={day} type="button"
          aria-label={new Date(year, index, day).toLocaleDateString('es-PA', { day: 'numeric', month: 'long', year: 'numeric' })}
          aria-pressed={dateValue(day) === value}
          onClick={() => { onChange(dateValue(day)); close(); }}>{day}</button>)}
      </div>
    </div>}
  </div>;
}
